import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

const Mandala = (props) => {
  const intl = useIntl();

  return (
    <svg
      role="img"
      focusable="false"
      aria-labelledby="svgMandalaTitle"
      aria-describedby="svgMandalaDescription"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 600 600"
    >
      <title id="svgMandalaTitle">
        <FormattedMessage id="image.coloring-book.mandala" />
      </title>
      <desc id="svgMandalaDescription">{intl.formatMessage({ id: 'image.coloring-book.mandala-description' })}</desc>
      <g id="Layer" data-name="Layer">
        <path
          onClick={() => props.onFill(0)}
          fill={props.colors[0]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M524.18,300.28c0,103.49-74,194.72-175.54,215-78.27,15.67-147.72-3.14-206-58.26-37.85-35.81-59.53-80.4-65.44-132.37C63.65,205.11,148.19,103,259.74,82.93c107.09-19.25,214.53,41,251.41,142.33A209.58,209.58,0,0,1,524.18,300.28ZM299.39,354.14c29.67.38,54.31-23.43,55.14-53.3.8-28.38-24.44-53.91-53.63-54.27-30.18-.37-55.39,23.29-55.84,52.44C244.58,329.35,268.61,353.74,299.39,354.14ZM504.6,234.86c-25.72-8.91-50.39-17.57-77-16.15a40.63,40.63,0,0,0-20.75,7.23,203.33,203.33,0,0,0-28.67,26c-8.56,9.27-15.65,19.9-23.46,30a14.36,14.36,0,0,0,2.49,1.67c19.3,5.09,38.41,11.19,58,14.84,13.47,2.51,27.42,1.45,39.5-7.46C475,276.07,489.7,256.39,504.6,234.86ZM334.21,346.09a32.36,32.36,0,0,0-.57,4.16c.56,16.36.29,32.81,2,49.06,2.28,22,10.83,41,32.64,50.34,17.79,7.61,36.06,14.08,54.15,21,1,.39,2.28.15,4.09.23.58-26.49,1.43-52.69-9-77.38a38.05,38.05,0,0,0-13.1-16.16A242.39,242.39,0,0,0,368.85,358C357.91,353.14,346.14,350.11,334.21,346.09Zm92.55-217.17C401.52,136,378,143.5,357.24,158c-8.43,5.91-13.66,13.88-17,23.7-5.65,16.6-6.29,33.76-7.15,50.93-.35,7-.06,14-.06,21.88,23.18-6.37,44.13-13.49,63.5-24.89,15.88-9.35,24.49-23.26,26.68-41.19,1.59-13,2.57-26.17,3.47-39.29C427.12,142.77,426.76,136.33,426.76,128.92ZM173.85,471a13,13,0,0,0,3.41-.37c18.24-7,36.7-13.6,54.6-21.42,18.17-7.93,28.24-23,30.43-42.36C264.42,388,264.85,368.93,266,350a8.72,8.72,0,0,0-.81-2.73,9.45,9.45,0,0,0-2.1,0c-20.57,5.48-40.51,12.53-59.07,23.2-15.16,8.71-24.51,21.35-27.23,38.75-.93,6-2.61,11.95-2.78,17.95C173.57,441.66,173.85,456.17,173.85,471ZM300.29,358a9.86,9.86,0,0,0-2,1.27c-13.39,16.35-25.35,33.59-34.06,53-6.9,15.33-7.66,30.66.44,45.52,7.34,13.47,15.52,26.49,23.67,39.5,3.16,5,7.25,9.5,11.37,14.8C312.83,495.94,324.22,479.84,333,462c7.28-14.75,10.12-29.45,3.69-45.55C328.05,394.66,314.59,376.19,300.29,358ZM265,254.18c.49-1.48,1-2.23.94-3-.85-18-.73-36.1-2.95-53.92-1.89-15.11-6.77-29.63-20.52-39.15-20.81-14.4-44.36-22-68.59-28.93a13,13,0,0,0-.83,3.3c1,19.15,1.31,38.39,3.54,57.4,1.69,14.29,7.72,26.77,20.58,35.66,16.78,11.6,35.4,18.52,54.48,24.69C256,251.68,260.43,252.85,265,254.18ZM94.12,234c16.24,23.06,31.22,44.55,53.91,58.72a41.29,41.29,0,0,0,19.37,5.95,125.24,125.24,0,0,0,30.73-2.43c15.52-3.3,30.72-8.19,47.07-12.68-13.74-20-26.95-38.15-44.73-52.38-8.48-6.79-17.59-12.8-28.91-12.68-9.07.11-18.33.46-27.13,2.39C128,224.51,111.77,229.34,94.12,234Zm150,84.8-.28-2.68c-18.8-4.58-37.43-10.07-56.44-13.44-14.51-2.57-29.38-2.59-42.49,6.95-20.53,15-35.27,34.91-49.64,55.54a10.86,10.86,0,0,0,2.39,1.63c18.73,5,37.3,10.78,56.27,14.52,12,2.36,24.81,2.52,36.05-4.48C213.25,362.37,228.89,340.77,244.1,318.82Zm55.67-75.26c14.65-19.19,28.68-37.75,37.23-60.12,6-15.64,3.74-30-3.77-43.77-7-12.78-15-25-22.87-37.23-3-4.72-6.88-8.91-10.73-13.82-15.42,19.62-29.87,38.86-38.06,62-2.89,8.17-4.17,16.49-1.69,25C267.35,201.34,282.92,222.23,299.77,243.56Zm205,122.32c-16-22.41-30.92-44.17-54-58.24a40.56,40.56,0,0,0-18.86-5.88c-26.32-.91-51.13,6.42-75.38,15.88-.28.11-.39.66-.95,1.68,13.27,18.77,27,37.31,45.63,52,11.88,9.39,24.94,12.6,39.28,10.43,13.95-2.11,27.78-5.22,41.52-8.46C489.36,371.55,496.48,368.61,504.72,365.88Z"
        />
        <path
          onClick={() => props.onFill(1)}
          fill={props.colors[1]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M299.39,354.14c-30.78-.4-54.81-24.79-54.33-55.13.45-29.15,25.66-52.81,55.84-52.44,29.19.36,54.43,25.89,53.63,54.27C353.7,330.71,329.06,354.52,299.39,354.14Z"
        />
        <path
          onClick={() => props.onFill(2)}
          fill={props.colors[2]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M504.6,234.86C489.7,256.39,475,276.07,454.73,291c-12.08,8.91-26,10-39.5,7.46-19.57-3.65-38.68-9.75-58-14.84a14.36,14.36,0,0,1-2.49-1.67c7.81-10.13,14.9-20.76,23.46-30a203.33,203.33,0,0,1,28.67-26,40.63,40.63,0,0,1,20.75-7.23C454.21,217.29,478.88,226,504.6,234.86Zm-34.93,11.41c-13.7-4.23-26.19-7.24-39.2-6.9-3.71.09-7.88.84-11,2.72-11.93,7.25-20.71,17.83-30,29.71,6.86,1.7,12.77,3.9,18.82,4.49,9.37.9,19.7,3.24,28.09.42C450.94,271.83,459.41,258.51,469.67,246.27Z"
        />
        <path
          onClick={() => props.onFill(3)}
          fill={props.colors[3]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M504.6,234.86C489.7,256.39,475,276.07,454.73,291c-12.08,8.91-26,10-39.5,7.46-19.57-3.65-38.68-9.75-58-14.84a14.36,14.36,0,0,1-2.49-1.67c7.81-10.13,14.9-20.76,23.46-30a203.33,203.33,0,0,1,28.67-26,40.63,40.63,0,0,1,20.75-7.23C454.21,217.29,478.88,226,504.6,234.86Zm-34.93,11.41c-13.7-4.23-26.19-7.24-39.2-6.9-3.71.09-7.88.84-11,2.72-11.93,7.25-20.71,17.83-30,29.71,6.86,1.7,12.77,3.9,18.82,4.49,9.37.9,19.7,3.24,28.09.42C450.94,271.83,459.41,258.51,469.67,246.27Z"
        />
        <path
          onClick={() => props.onFill(4)}
          fill={props.colors[4]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M334.21,346.09c11.93,4,23.7,7.05,34.64,11.92a242.39,242.39,0,0,1,35.56,19.32,38.05,38.05,0,0,1,13.1,16.16c10.42,24.69,9.57,50.89,9,77.38-1.81-.08-3.07.16-4.09-.23-18.09-6.91-36.36-13.38-54.15-21-21.81-9.34-30.36-28.37-32.64-50.34-1.69-16.25-1.42-32.7-2-49.06A32.36,32.36,0,0,1,334.21,346.09Zm20.89,29.45c.49,7.21.18,13,1.39,18.38,2.05,9.18,2.82,19.86,8.16,26.82C374.06,433,389.5,437,405.33,442.62c-1.24-10.68-1.65-20-3.59-29-1.37-6.33-3.35-13.69-7.64-18C383.83,385.29,369.88,380.89,355.1,375.54Z"
        />
        <path
          onClick={() => props.onFill(5)}
          fill={props.colors[5]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M426.76,128.92c0,7.41.36,13.85-.08,20.22-.9,13.12-1.88,26.25-3.47,39.29-2.19,17.93-10.8,31.84-26.68,41.19-19.37,11.4-40.32,18.52-63.5,24.89,0-7.88-.29-14.9.06-21.88.86-17.17,1.5-34.33,7.15-50.93,3.34-9.82,8.57-17.79,17-23.7C378,143.5,401.52,136,426.76,128.92Zm-22.09,29.21C390.46,163.52,377,168.24,366,177.79A13.23,13.23,0,0,0,362.6,182c-6.11,13.33-6.48,27.6-7.37,43.38,14.91-5.91,29-10.53,40.09-21.15a14.19,14.19,0,0,0,3.11-5.14C403.3,186.28,404.27,172.86,404.67,158.13Z"
        />
        <path
          onClick={() => props.onFill(6)}
          fill={props.colors[6]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M173.85,471c0-14.79-.28-29.3.13-43.79.17-6,1.85-12,2.78-17.95,2.72-17.4,12.07-30,27.23-38.75,18.56-10.67,38.5-17.72,59.07-23.2a9.45,9.45,0,0,1,2.1,0A8.72,8.72,0,0,1,266,350c-1.12,18.95-1.55,38-3.68,56.83-2.19,19.36-12.26,34.43-30.43,42.36-17.9,7.82-36.36,14.38-54.6,21.42A13,13,0,0,1,173.85,471Zm20.82-28.49c14.71-5.17,27.82-10.19,38.78-19.52a12.54,12.54,0,0,0,3.3-4.28c6-13.35,6.89-27.53,7.2-43-14.81,5.43-28.62,10.3-39.7,20.6a10.85,10.85,0,0,0-2.43,3.45C195.94,412.91,195.5,427,194.67,442.47Z"
        />
        <path
          onClick={() => props.onFill(7)}
          fill={props.colors[7]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M300.29,358c14.3,18.17,27.76,36.64,36.44,58.38,6.43,16.1,3.59,30.8-3.69,45.55-8.82,17.89-20.21,34-33.35,50.14-4.12-5.3-8.21-9.76-11.37-14.8-8.15-13-16.33-26-23.67-39.5-8.1-14.86-7.34-30.19-.44-45.52,8.71-19.39,20.67-36.63,34.06-53A9.86,9.86,0,0,1,300.29,358Zm-2.48,117.62,3.58,0c5.56-10.89,11.87-21.49,16.36-32.81,1.95-4.93,1.7-11.93-.23-17-3.6-9.34-9.12-18-14-26.81-1-1.78-2.51-3.26-5.05-6.49-6.34,12.6-12.39,23.53-17.29,35A19.12,19.12,0,0,0,281,441C286,452.8,292.12,464.12,297.81,475.64Z"
        />
        <path
          onClick={() => props.onFill(8)}
          fill={props.colors[8]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M265,254.18c-4.57-1.33-9-2.5-13.35-3.91-19.08-6.17-37.7-13.09-54.48-24.69-12.86-8.89-18.89-21.37-20.58-35.66-2.23-19-2.49-38.25-3.54-57.4a13,13,0,0,1,.83-3.3c24.23,6.9,47.78,14.53,68.59,28.93,13.75,9.52,18.63,24,20.52,39.15,2.22,17.82,2.1,35.94,2.95,53.92C266,252,265.49,252.7,265,254.18ZM194.17,158c1.19,10.5,1.69,19.7,3.44,28.64,1.18,6,2.7,13,6.56,17.25,10.31,11.42,25,15.55,40.61,21.7-1.33-11.27-1.85-21-3.82-30.38-1.25-5.93-3.31-12.75-7.36-16.83C223.31,168,209.42,163.61,194.17,158Z"
        />
        <path
          onClick={() => props.onFill(9)}
          fill={props.colors[9]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M94.12,234c17.65-4.68,33.84-9.51,50.31-13.11,8.8-1.93,18.06-2.28,27.13-2.39,11.32-.12,20.43,5.89,28.91,12.68,17.78,14.23,31,32.37,44.73,52.38-16.35,4.49-31.55,9.38-47.07,12.68a125.24,125.24,0,0,1-30.73,2.43A41.29,41.29,0,0,1,148,292.74C125.34,278.57,110.36,257.08,94.12,234Zm37,10.24-.89,3c5.51,6.06,11.1,12,16.49,18.18,9.12,10.38,20.28,15.08,34.07,12.49,9.34-1.76,18.65-3.72,29.33-5.87-10-12.64-18.92-23.6-31.5-30.7a14.66,14.66,0,0,0-8.09-2C157.39,240.78,144.27,242.6,131.14,244.26Z"
        />
        <path
          onClick={() => props.onFill(10)}
          fill={props.colors[10]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M244.1,318.82c-15.21,21.95-30.85,43.55-54.14,58-11.24,7-24.05,6.84-36.05,4.48-19-3.74-37.54-9.55-56.27-14.52a10.86,10.86,0,0,1-2.39-1.63c14.37-20.63,29.11-40.59,49.64-55.54,13.11-9.54,28-9.52,42.49-6.95,19,3.37,37.64,8.86,56.44,13.44Zm-33.76,9.94c-9.75-2.07-17.52-4.37-25.46-5.23-7.31-.81-15.6-2.14-22,.39-14.27,5.62-22.94,18.32-33.71,31.38,11.42,2.11,21,4.44,30.71,5.47,6,.64,13.09,1,18.31-1.45C191.41,353.08,199.92,341.18,210.34,328.76Z"
        />
        <path
          onClick={() => props.onFill(11)}
          fill={props.colors[11]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M299.77,243.56c-16.85-21.33-32.42-42.22-39.89-67.92-2.48-8.56-1.2-16.88,1.69-25,8.19-23.11,22.64-42.35,38.06-62,3.85,4.91,7.7,9.1,10.73,13.82,7.87,12.26,15.92,24.45,22.87,37.23,7.51,13.79,9.75,28.13,3.77,43.77C328.45,205.81,314.42,224.37,299.77,243.56Zm0-118.89c-8.91,12.61-16.39,24.48-19.88,38.47a8.84,8.84,0,0,0-.3,3.6c2.75,15.12,11.11,27.38,20,40.77,8.72-12.78,16.62-24.44,19.65-38.56a18.05,18.05,0,0,0-.47-8.41C315.11,147.75,308,136.72,299.8,124.67Z"
        />
        <path
          onClick={() => props.onFill(12)}
          fill={props.colors[12]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M504.72,365.88c-8.24,2.73-15.36,5.67-22.75,7.41-13.74,3.24-27.57,6.35-41.52,8.46-14.34,2.17-27.4-1-39.28-10.43-18.58-14.69-32.36-33.23-45.63-52,.56-1,.67-1.57.95-1.68,24.25-9.46,49.06-16.79,75.38-15.88a40.56,40.56,0,0,1,18.86,5.88C473.8,321.71,488.77,343.47,504.72,365.88ZM469.9,354.77c-9.86-12.06-18.71-23-31.14-30.28a13.63,13.63,0,0,0-5.11-1.79c-15-1.74-29,2.37-44.11,6.49,9.35,11.58,18,22.2,30,29.57a14.11,14.11,0,0,0,5,2C439.75,363.24,454,358.64,469.9,354.77Z"
        />
        <path
          onClick={() => props.onFill(13)}
          fill={props.colors[13]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M469.67,246.27c-10.26,12.24-18.73,25.56-33.22,30.44-8.39,2.82-18.72.48-28.09-.42-6.05-.59-12-2.79-18.82-4.49,9.25-11.88,18-22.46,30-29.71,3.09-1.88,7.26-2.63,11-2.72C443.48,239,456,242,469.67,246.27Zm-36.92,29.17c14.07-5.07,22.65-16.47,32.84-28.24-15.33-2.85-28.77-8.28-44.44-3.75C438.61,251.74,441.66,261.3,432.75,275.44Z"
        />
        <path
          onClick={() => props.onFill(14)}
          fill={props.colors[14]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M355.1,375.54c14.78,5.35,28.73,9.75,39,20.08,4.29,4.32,6.27,11.68,7.64,18,1.94,9,2.35,18.31,3.59,29C389.5,437,374.06,433,364.65,420.74c-5.34-7-6.11-17.64-8.16-26.82C355.28,388.51,355.59,382.75,355.1,375.54Zm37.26,22.12c-.38,13.85-8.95,23.75-28.73,18.87C374.45,429,388,433.33,402.48,439.1,400.53,423.86,401.22,409.64,392.36,397.66Z"
        />
        <path
          onClick={() => props.onFill(15)}
          fill={props.colors[15]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M404.67,158.13c-.4,14.73-1.37,28.15-6.24,41a14.19,14.19,0,0,1-3.11,5.14c-11.06,10.62-25.18,15.24-40.09,21.15.89-15.78,1.26-30,7.37-43.38a13.23,13.23,0,0,1,3.36-4.24C377,168.24,390.46,163.52,404.67,158.13ZM392.3,204.37c8.83-13.5,8.54-27.64,9.78-41.8-15.52,3.22-34.3,14.44-36.57,21.5C382,180.21,388.89,185.12,392.3,204.37Z"
        />
        <path
          onClick={() => props.onFill(16)}
          fill={props.colors[16]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M194.67,442.47c.83-15.5,1.27-29.56,7.15-42.75a10.85,10.85,0,0,1,2.43-3.45c11.08-10.3,24.89-15.17,39.7-20.6-.31,15.47-1.19,29.65-7.2,43a12.54,12.54,0,0,1-3.3,4.28C222.49,432.28,209.38,437.3,194.67,442.47Zm2.72-4.23c15.44-3.44,33.73-14.29,37-22-6.84,2.54-13.27,2.81-19.23-1.3s-7.31-10.42-8.45-17.13C198.57,410.13,198.33,423.94,197.39,438.24Z"
        />
        <path
          onClick={() => props.onFill(17)}
          fill={props.colors[17]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M297.81,475.64C292.12,464.12,286,452.8,281,441a19.12,19.12,0,0,1,.21-13.47c4.9-11.44,10.95-22.37,17.29-35,2.54,3.23,4.07,4.71,5.05,6.49,4.84,8.85,10.36,17.47,14,26.81,1.93,5,2.18,12,.23,17-4.49,11.32-10.8,21.92-16.36,32.81Zm2-3.82c7.66-13.06,16.5-24.22,17.52-40.39-11.2,13-22.35,14.4-34.89,1.54C283.69,447.46,291.62,459,299.81,471.82Z"
        />
        <path
          onClick={() => props.onFill(18)}
          fill={props.colors[18]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M194.17,158c15.25,5.61,29.14,10,39.43,20.38,4.05,4.08,6.11,10.9,7.36,16.83,2,9.4,2.49,19.11,3.82,30.38-15.6-6.15-30.3-10.28-40.61-21.7-3.86-4.28-5.38-11.24-6.56-17.25C195.86,177.7,195.36,168.5,194.17,158Zm40,25.38c-9.3-11.58-22.79-16-36.85-21.53,1.17,15,1.15,29,9.39,41C208.12,188.48,216.5,179.41,234.16,183.38Z"
        />
        <path
          onClick={() => props.onFill(19)}
          fill={props.colors[19]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M131.14,244.26c13.13-1.66,26.25-3.48,39.41-4.85a14.66,14.66,0,0,1,8.09,2c12.58,7.1,21.45,18.06,31.5,30.7-10.68,2.15-20,4.11-29.33,5.87-13.79,2.59-24.95-2.11-34.07-12.49-5.39-6.15-11-12.12-16.49-18.18Zm45.65-.56c-14.45-4.61-28,.6-43.12,3.53,10.43,11.77,19,23.21,34,29.4C158.45,259.46,161.46,250.15,176.79,243.7Z"
        />
        <path
          onClick={() => props.onFill(20)}
          fill={props.colors[20]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M210.34,328.76c-10.42,12.42-18.93,24.32-32.19,30.56-5.22,2.45-12.26,2.09-18.31,1.45-9.71-1-19.29-3.36-30.71-5.47,10.77-13.06,19.44-25.76,33.71-31.38,6.44-2.53,14.73-1.2,22-.39C192.82,324.39,200.59,326.69,210.34,328.76Zm-76,24.19c15.51,6,35.76,7.68,43.59,3.49-7.31-1.85-12.79-5.32-15.1-12.26-2.24-6.75.15-12.72,3.41-18.81C152.46,330.83,143.86,341.89,134.34,353Z"
        />
        <path
          onClick={() => props.onFill(21)}
          fill={props.colors[21]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M299.8,124.67c8.22,12,15.31,23.08,19,35.87a18.05,18.05,0,0,1,.47,8.41c-3,14.12-10.93,25.78-19.65,38.56-8.91-13.39-17.27-25.65-20-40.77a8.84,8.84,0,0,1,.3-3.6C283.41,149.15,290.89,137.28,299.8,124.67ZM316.73,168c-.68-14.81-9.18-26.22-16.61-38.51-10.93,12.54-19.15,31.78-16.82,38.65C294.8,155.5,304.85,155.52,316.73,168Z"
        />
        <path
          onClick={() => props.onFill(22)}
          fill={props.colors[22]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M469.9,354.77c-15.94,3.87-30.15,8.47-45.37,6a14.11,14.11,0,0,1-5-2c-11.93-7.37-20.62-18-30-29.57,15.06-4.12,29.12-8.23,44.11-6.49a13.63,13.63,0,0,1,5.11,1.79C451.19,331.81,460,342.71,469.9,354.77Zm-35.17-29.42c.61,6.65,2.22,12.9,1.46,18.85-.92,7.27-7.77,10-13.84,13.15,14.61,3.32,28.33,0,43-4.24C455.44,341.88,447.07,330.78,434.73,325.35Z"
        />
        <path
          onClick={() => props.onFill(23)}
          fill={props.colors[23]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M432.75,275.44c8.91-14.14,5.86-23.7-11.6-32,15.67-4.53,29.11.9,44.44,3.75C455.4,259,446.82,270.37,432.75,275.44Z"
        />
        <path
          onClick={() => props.onFill(24)}
          fill={props.colors[24]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M392.36,397.66c8.86,12,8.17,26.2,10.12,41.44-14.49-5.77-28-10.15-38.85-22.57C383.41,421.41,392,411.51,392.36,397.66Z"
        />
        <path
          onClick={() => props.onFill(25)}
          fill={props.colors[25]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M392.3,204.37c-3.41-19.25-10.34-24.16-26.79-20.3,2.27-7.06,21.05-18.28,36.57-21.5C400.84,176.73,401.13,190.87,392.3,204.37Z"
        />
        <path
          onClick={() => props.onFill(26)}
          fill={props.colors[26]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M197.39,438.24c.94-14.3,1.18-28.11,9.3-40.42,1.14,6.71,2.54,13.06,8.45,17.13s12.39,3.84,19.23,1.3C231.12,424,212.83,434.8,197.39,438.24Z"
        />
        <path
          onClick={() => props.onFill(27)}
          fill={props.colors[27]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M299.81,471.82C291.62,459,283.69,447.46,282.44,433c12.54,12.86,23.69,11.48,34.89-1.54C316.31,447.6,307.47,458.76,299.81,471.82Z"
        />
        <path
          onClick={() => props.onFill(28)}
          fill={props.colors[28]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M234.16,183.38c-17.66-4-26,5.1-27.46,19.45-8.24-12-8.22-26-9.39-41C211.37,167.42,224.86,171.8,234.16,183.38Z"
        />
        <path
          onClick={() => props.onFill(29)}
          fill={props.colors[29]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M176.79,243.7c-15.33,6.45-18.34,15.76-9.17,32.93-15-6.19-23.52-17.63-34-29.4C148.81,244.3,162.34,239.09,176.79,243.7Z"
        />
        <path
          onClick={() => props.onFill(30)}
          fill={props.colors[30]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M134.34,353c9.52-11.06,18.12-22.12,31.9-27.58-3.26,6.09-5.65,12.06-3.41,18.81,2.31,6.94,7.79,10.41,15.1,12.26C170.1,360.63,149.85,358.92,134.34,353Z"
        />
        <path
          onClick={() => props.onFill(31)}
          fill={props.colors[31]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M316.73,168c-11.88-12.5-21.93-12.52-33.43.14-2.33-6.87,5.89-26.11,16.82-38.65C307.55,141.8,316.05,153.21,316.73,168Z"
        />
        <path
          onClick={() => props.onFill(32)}
          fill={props.colors[32]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M434.73,325.35c12.34,5.43,20.71,16.53,30.6,27.76-14.65,4.25-28.37,7.56-43,4.24,6.07-3.16,12.92-5.88,13.84-13.15C437,338.25,435.34,332,434.73,325.35Z"
        />
      </g>
    </svg>
  );
};

Mandala.propTypes = {
  onFill: PropTypes.func,
  colors: PropTypes.array,
};

export default Mandala;
